import {createAsyncThunk, createSelector, createSlice} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _prefix = "/support";

export const fetchSupportPaging = createAsyncThunk(
    "support/fetchSupportPaging",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/page`,
            method: "GET",
            params: AppUtil.toSnakeCaseKey(params),
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const fetchSupportDetail = createAsyncThunk(
    "support/fetchSupportDetail",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/detail/${params}`,
            method: "GET",
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceCreateSupport = createAsyncThunk(
    "support/reduceCreateSupport",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}`,
            method: "POST",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.create.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceUpdateSupport = createAsyncThunk(
    "support/reduceUpdateSupport",
    async (data) => {
        const result = await httpRequest({
            url: `${_prefix}/update/${data.id}`,
            method: "PUT",
            data: AppUtil.toSnakeCaseKey(data.params),
            successMessage: 'toast.update.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

export const reduceDeleteSupport = createAsyncThunk(
    "support/reduceDeleteSupport",
    async (params) => {
        const result = await httpRequest({
            url: `${_prefix}/delete`,
            method: "DELETE",
            data: AppUtil.toSnakeCaseKey(params),
            successMessage: 'toast.remove.200'
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);


const initialState = {
    list: [],
    detail: {}
};

const slice = createSlice({
    name: "support",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [fetchSupportPaging.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.list = payload.content;
            }
        },
        [fetchSupportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.detail = payload;
            }
        },
    }
});

const { reducer } = slice;
export default reducer;

export const getSupportPagingList = createSelector(
    state => state.support.list,
    list => list
)

export const getSupportDetail = createSelector(
    state => state.support.detail,
    detail => detail
)
